<template>
  <b-tab title="Saídas" class="m-0 p-0">
    <div class="tab-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE SAIDAS DE EQUIPAMENTOS :::::::::::::::::::::::::::: -->
      <b-table
        bordered
        hover
        small
        head-variant="light"
        :per-page="perPage"
        :current-page="currentPage"
        :items="getFilterSaidas(filtro)"
        :fields="fields.saida"
      >
        <template #cell(data)="data">
          <div>
            <p class="pt-0 pb-0">
              {{ moment(data.item.data).format("DD/MM/YYYY") }}
            </p>
          </div>
        </template>

        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)" v-b-tooltip.hover title="Editar">
              <b-icon icon="pencil-square" variant="primary"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="itens(data.item)" v-b-tooltip.hover title="Itens">
              <b-icon icon="diagram3" variant="info"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="protocolo(data.item)" v-b-tooltip.hover title="Gerar Protocolo">
              <b-icon icon="file-earmark-medical" variant="warning"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="display(data.item)" v-b-tooltip.hover title="Arquivo">
              <b-icon icon="file-arrow-down" variant="success"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- :::::::::::::::::::::::::::: BARRA DE AÇÕES :::::::::::::::::::::::::::: -->
    <div class="menu-acoes pb-2">
      <div id="search-bar">
        <b-col cols="12" class="p-1 pr-0">
          <b-form inline>
            <b-button size="sm" class="pl-2 pr-3" variant="info" @click="adicionar()">
              <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2" />Adicionar
            </b-button>
            <b-form-input
              id="atv-desc-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Descrição"
              v-model="filtro.descricao"
            />
            <b-form-input
              id="atv-cliente-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Cliente"
              v-model="filtro.cliente"
            />
            <b-form-input
              id="atv-rec-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Quem recebeu"
              v-model="filtro.recebeu"
            />
            <b-icon icon="search" variant="light" scale="1.2" class="m-1" />
            <b-pagination
              class="m-1 ml-2"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="table-equip"
              limit="3"
              size="sm"
            ></b-pagination>
          </b-form>
        </b-col>
      </div>
      <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
      <saida-modal ref="editorSaida" />
      <itens-list-modal ref="saidaItensList" />
      <protocolo-modal ref="protocoloPrintModal" />
      <display-protocolo-modal ref="displayProtocolo" />
    </div>
  </b-tab>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useEntradaSaidaStore } from "@/stores/EntradaSaidaStore";
import Saida from "@/models/Saida";
import TableFields from "@/tools/TableFields";
import SaidaModal from "@/components/modals/armazem/SaidaModal";
import SaidaItensListModal from "@/components/modals/armazem/SaidaItensListModal";
import ProtocoloPrintModal from "@/components/modals/armazem/ProtocoloPrintModal";
import DisplayProtocoloModal from "@/components/modals/armazem/DisplayProtocoloModal";
import Files from "@/http/files";

export default {
  name: "SaidaTabList",

  data() {
    return {
      fields: new TableFields(),
      filtro: {
        descricao: "",
        cliente: "",
        recebeu: "",
      },
      saida: new Saida(0, "Nova Entrada", "", new Date(), "", "", "", ""),
      files: new Files(this.$http),
      perPage: 50,
      currentPage: 1,
    };
  },

  components: {
    "saida-modal": SaidaModal,
    "itens-list-modal": SaidaItensListModal,
    "protocolo-modal": ProtocoloPrintModal,
    "display-protocolo-modal": DisplayProtocoloModal,
  },

  computed: {
    rows() {
      return this.getFilterSaidas(this.filtro).length;
    },
  },

  methods: {
    adicionar() {
      this.saida = new Saida(0, "Nova Entrada", "", new Date(), "", "", "", "");
      this.$refs.editorSaida.call(this.saida);
    },

    display(saida) {
      this.files.downloadProtocolo(saida.id).then((response) => this.$refs.displayProtocolo.call(response));
    },

    protocolo(saida) {
      this.$refs.protocoloPrintModal.call(saida);
    },

    editar(saida) {
      this.$refs.editorSaida.call(saida);
    },

    itens(saida) {
      this.$refs.saidaItensList.call(saida);
    },
  },

  setup() {
    const store = useSgcqStore();
    const saidaStore = useEntradaSaidaStore();
    const { getSaidaItens } = storeToRefs(saidaStore);
    const { getFilterSaidas } = storeToRefs(saidaStore);

    return {
      store,
      saidaStore,
      getFilterSaidas,
      getSaidaItens,
    };
  },
};
</script>

<style lang="scss" scoped>
#atv-desc-filter {
  width: 18rem;
}
#atv-cliente-filter {
  width: 14rem;
}
#atv-rec-filter {
  width: 14rem;
}
.menu-acoes {
  background-color: #112a4a;
}
</style>
